/* Café Onger Ós — storefront behaviour.
   Everything is progressive enhancement: markup renders and reads fine
   without this file, JS only adds motion and disclosure. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- header */

  function initHeader() {
    var header = document.querySelector('[data-oo-header]');
    if (!header) return;

    if (header.classList.contains('oo-header--overlay')) {
      var onScroll = function () {
        header.classList.toggle('is-scrolled', window.scrollY > 60);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    var drawer = document.querySelector('[data-oo-drawer]');
    if (!drawer) return;
    var toggles = document.querySelectorAll('[data-oo-drawer-toggle]');
    var lastFocus = null;

    function setOpen(open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', String(open)); });
      if (open) {
        lastFocus = document.activeElement;
        var first = drawer.querySelector('a, button');
        if (first) first.focus();
      } else if (lastFocus) {
        lastFocus.focus();
      }
    }

    toggles.forEach(function (t) {
      t.addEventListener('click', function () {
        setOpen(!drawer.classList.contains('is-open'));
      });
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
    });
  }

  /* ------------------------------------------------------------ hero fades */

  function initHeroSlides() {
    document.querySelectorAll('[data-oo-hero-slides]').forEach(function (root) {
      var slides = root.querySelectorAll('.oo-hero__slide');
      if (slides.length < 2 || reduceMotion) return;
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 4500;
      var i = 0;
      setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, interval);
    });
  }

  /* ------------------------------------------------------------ slideshows */

  function initSlideshows() {
    document.querySelectorAll('[data-oo-slideshow]').forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('.oo-slideshow__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-oo-dot]'));
      if (slides.length < 2) return;
      var index = 0;
      var timer = null;
      var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduceMotion;
      var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;

      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          s.classList.toggle('is-active', i === index);
          s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
          d.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      function restart() {
        if (!autoplay) return;
        clearInterval(timer);
        timer = setInterval(function () { show(index + 1); }, speed);
      }

      var prev = root.querySelector('[data-oo-prev]');
      var next = root.querySelector('[data-oo-next]');
      if (prev) prev.addEventListener('click', function () { show(index - 1); restart(); });
      if (next) next.addEventListener('click', function () { show(index + 1); restart(); });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { show(i); restart(); });
      });

      show(0);
      restart();
    });
  }

  /* -------------------------------------------------------- gallery albums */

  function initAlbums() {
    document.querySelectorAll('[data-oo-gallery]').forEach(function (root) {
      var bar = root.querySelector('[data-oo-tabs]');
      var albums = Array.prototype.slice.call(root.querySelectorAll('[data-oo-album]'));
      if (!bar || bar.getAttribute('data-built') === 'true') return;

      /* One album needs no filter. */
      if (albums.length < 2) {
        bar.hidden = true;
        return;
      }
      bar.setAttribute('data-built', 'true');

      function makeTab(label, key, active) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'oo-tab' + (active ? ' is-active' : '');
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', String(active));
        b.setAttribute('data-oo-tab', key);
        b.textContent = label;
        return b;
      }

      var tabs = [makeTab(bar.getAttribute('data-all-label') || 'Alle', 'all', true)];
      albums.forEach(function (a) {
        tabs.push(makeTab(a.getAttribute('data-oo-album-title') || 'Album', a.getAttribute('data-oo-album'), false));
      });

      tabs.forEach(function (tab) {
        bar.appendChild(tab);
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-oo-tab');
          tabs.forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', String(on));
          });
          albums.forEach(function (a) {
            a.hidden = !(key === 'all' || a.getAttribute('data-oo-album') === key);
          });
        });
      });
    });
  }

  /* -------------------------------------------------------------- lightbox */

  function initLightbox() {
    var box = document.querySelector('[data-oo-lightbox]');
    if (!box) return;
    var img = box.querySelector('.oo-lightbox__img');
    var closeBtn = box.querySelector('[data-oo-lightbox-close]');
    var lastFocus = null;

    function close() {
      box.classList.remove('is-open');
      box.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }

    document.querySelectorAll('[data-oo-lightbox-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var src = trigger.getAttribute('data-oo-lightbox-open');
        if (!src) return;
        lastFocus = trigger;
        img.src = src;
        img.alt = trigger.getAttribute('data-alt') || '';
        box.classList.add('is-open');
        box.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        closeBtn.focus();
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    box.addEventListener('click', function (e) {
      if (e.target === box) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.classList.contains('is-open')) close();
    });
  }

  function init() {
    initHeader();
    initHeroSlides();
    initSlideshows();
    initAlbums();
    initLightbox();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run when the theme editor swaps a section or block in. */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
